import { apiRequest } from "./client";

// Зеркалит backend AuditLogEntry (api/v1/audit_log.py).
export interface AuditLogEntry {
  id: string;
  actor_user_id: string | null;
  action: string;
  target_kind: string | null;
  target_id: string | null;
  payload: Record<string, unknown> | null;
  ip_hash: string | null;
  created_at: string; // ISO 8601
}

export interface AuditLogListResponse {
  items: AuditLogEntry[];
  total: number;
}

export interface AuditLogMetaResponse {
  actions: string[];
  target_kinds: string[];
}

export interface AuditLogQuery {
  action?: string;
  actor_user_id?: string;
  actor_email?: string;
  target_kind?: string;
  after?: string;
  before?: string;
  limit?: number;
  offset?: number;
}

function buildQuery(q: AuditLogQuery): string {
  const params = new URLSearchParams();
  if (q.action) params.set("action", q.action);
  if (q.actor_user_id) params.set("actor_user_id", q.actor_user_id);
  if (q.actor_email) params.set("actor_email", q.actor_email);
  if (q.target_kind) params.set("target_kind", q.target_kind);
  if (q.after) params.set("after", q.after);
  if (q.before) params.set("before", q.before);
  if (q.limit !== undefined) params.set("limit", String(q.limit));
  if (q.offset !== undefined) params.set("offset", String(q.offset));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export const auditLogApi = {
  list: (q: AuditLogQuery = {}) =>
    apiRequest<AuditLogListResponse>(`/audit-log${buildQuery(q)}`),
  meta: () => apiRequest<AuditLogMetaResponse>("/audit-log/meta"),
};
